import http from "../http";
const { post, put, deleteRequest } = http;

export default {
  createNews(data, config) {
    return post(`/cmoapi/api/create_news`, data, config);
  },
  editNews(data, config) {
    return put(`/cmoapi/api/edit_news`, data, config);
  },
  viewNews(id, data, config) {
    return put(`/cmoapi/api/news_view?id=${id}`, data, config);
  },
  getUploadUrl(data, config) {
    return post(`/cmoapi/api/get_upload_url`, data, config);
  },
  putUploadFile(url, data, config) {
    return put(url, data, config);
  },
  importWinners(data, config) {
    return post(`/cmoapi/api/import_winners`, data, config);
  },
  delWinners(id, config) {
    return deleteRequest(`/cmoapi/api/del_winners?year_id=${id}`, config);
  },
};
